class Wheel {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.initiateVars();
    this.bindEvents();
  }

  unmount() {
    this.ui.wheelItems.forEach((item) => {
      this.ioObserver.unobserve(item);
    });
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.wheel = this.element.querySelector('[data-ref="wheel-list"]');
    this.ui.wheelIndex = this.element.querySelector('[data-ref="wheel-index"]');
    this.ui.wheelItems = this.element.querySelectorAll('[data-ref="wheel-item"]');
  }

  initiateVars() {
    this.translate = 0;
    this.inc = 16;
    this.previousIndex = 1;
    this.options = {
      root: this.ui.wheel,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0,
    };

    this.ioObserver = new IntersectionObserver(this.ioCallback.bind(this), this.options);
  }

  bindEvents() {
    this.ui.wheelItems.forEach((item) => {
      this.ioObserver.observe(item);
    });
  }

  ioCallback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const index = entry.target.getAttribute('data-index');
        const delta = parseInt(index) - this.previousIndex;

        if (delta > 0) {
          this.translate += this.inc;
          this.ui.wheelIndex.style.transform = `translate3d(0, -${this.translate}px, 0)`;
        } else if (delta === 0) {
          this.translate = 0;
        } else {
          this.translate -= this.inc;
          this.ui.wheelIndex.style.transform = `translate3d(0, ${this.translate == 0 ? this.translate : -this.translate}px, 0)`;
        }

        this.previousIndex = parseInt(index);
      }

      entries[0].target.classList.add('carousel__item--is-active');
      entry.target.classList.toggle('carousel__item--is-active', entry.isIntersecting);
    });
  }
}

export default Wheel;
